'use client';

import BaseMapCard from '@alltrails/shared/components/MapCard';
import { useIntl } from 'react-intl';
import { Map } from '@alltrails/shared/types/map';
import { fullName } from '@alltrails/shared/utils/formatters/textFormatters';
import getLocationName from '@alltrails/shared/utils/getLocationName';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import useUser from '@alltrails/context/hooks/useUser';
import { useSelector } from '../../redux';
import { UserCustomRoute } from '../../types/CustomRoute';

type MapCardProps = {
  currentResult: UserCustomRoute;
  variant?: 'standard' | 'small';
  showDelete?: boolean;
  onDeleteClick?: (mapId: number) => void;
  onFavoriteClick?: () => void;
  isFavorite?: boolean;
  onCardClick?: () => void;
  onCardMouseEnter?: () => void;
  onCardMouseLeave?: () => void;
  className?: string;
};

const UserCustomRouteCard = ({
  currentResult,
  variant = 'standard',
  showDelete = false,
  onDeleteClick,
  onFavoriteClick,
  isFavorite,
  onCardClick,
  onCardMouseEnter,
  onCardMouseLeave,
  className
}: MapCardProps) => {
  const languageRegionCode = useLanguageRegionCode();
  const displayMetric = useSelector(state => state.context.displayMetric);
  const intl = useIntl();
  const user = useUser();
  const isFirstParty = user?.id === currentResult.user.id;

  const convertUserCustomRouteToMap = (route: UserCustomRoute): Map => {
    const { id, name, distance, duration_minutes, slug, user, state_name: region, country_name, city_name: city } = route;
    const { first_name: firstName, last_name: lastName } = user;
    return {
      id,
      name,
      meters: distance,
      minutes: duration_minutes,
      slug,
      user: { name: fullName({ firstName, lastName }), ...user },
      locationName: getLocationName({ region, country_name, city })
    };
  };

  return (
    <BaseMapCard
      className={className}
      languageRegionCode={languageRegionCode}
      onCardClick={onCardClick}
      onCardMouseEnter={onCardMouseEnter}
      onCardMouseLeave={onCardMouseLeave}
      onFavoriteClick={onFavoriteClick}
      isFavorite={isFavorite}
      variant={variant}
      map={convertUserCustomRouteToMap(currentResult)}
      useMetric={displayMetric}
      isFirstParty={isFirstParty}
      maxPhotos={0}
      blockNavigation
      {...(showDelete && onDeleteClick
        ? { deleteButton: { onClick: () => onDeleteClick(currentResult.id), title: intl.formatMessage({ defaultMessage: 'Delete' }) } }
        : {})}
      isCustomRoute
    />
  );
};

export default UserCustomRouteCard;
